import { ALL_TOOLS } from './toolCatalog';

// ── Tool tile colours — each category owns a hue region (rainbow across
// categories); tools fan out within a ±BAND window around it. catIdx/catCount
// come from the ALL_TOOLS ordering (form-auto-fillup first, then megamenu).
// Shared by the tools grid and the related-tools row on every tool page, so a
// tool keeps the same tile colour wherever it is drawn. ──
const CATEGORY_HUE = { pdf: 265, image: 200, text: 150, video: 35, general: 320, result: 175 };
const FALLBACK_HUE = 220;
const TILE_BAND = 92; // hue spread each side of the category hue

// slug → { categoryId, catIdx, catCount } built in ALL_TOOLS order.
const _tileCatCount = ALL_TOOLS.reduce(
    (m, t) => ((m[t.categoryId] = (m[t.categoryId] || 0) + 1), m),
    {},
);
const _tileRunning = {};
const TOOL_TILE = new Map();
ALL_TOOLS.forEach((t) => {
    const catIdx = (_tileRunning[t.categoryId] = (_tileRunning[t.categoryId] ?? -1) + 1);
    TOOL_TILE.set(t.slug, { categoryId: t.categoryId, catIdx, catCount: _tileCatCount[t.categoryId] });
});

// CSS gradient for a tool tile.
export const tileGradient = (tool) => {
    const meta = TOOL_TILE.get(tool.slug) || { categoryId: tool.categoryId, catIdx: 0, catCount: 1 };
    const base = CATEGORY_HUE[meta.categoryId] ?? FALLBACK_HUE;
    const n = meta.catCount || 1;
    const i = meta.catIdx || 0;
    const frac = n > 1 ? i / (n - 1) : 0.5;
    const hue = ((base - TILE_BAND + 2 * TILE_BAND * frac) % 360 + 360) % 360;
    const sat = 78 - (i % 3) * 6;
    const lTop = 60 - (i % 4) * 3;
    return `linear-gradient(135deg, hsl(${hue.toFixed(0)} ${sat}% ${lTop}%), hsl(${((hue + 16) % 360).toFixed(0)} ${sat}% ${lTop - 12}%))`;
};

// Brand squircle shape (superellipse from the module-icon SVGs), applied as a
// CSS mask so the per-tool gradient fills the exact icon silhouette.
const SQUIRCLE_MASK =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72' preserveAspectRatio='none'%3E%3Cpath d='M.25,36C.25,10,10,.25,36,.25s35.75,9.75,35.75,35.75-9.75,35.75-35.75,35.75S.25,62,.25,36Z' fill='black'/%3E%3C/svg%3E\")";

export const squircleStyle = {
    WebkitMaskImage: SQUIRCLE_MASK,
    maskImage: SQUIRCLE_MASK,
    WebkitMaskSize: '100% 100%',
    maskSize: '100% 100%',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
};
